
import { InterceptMiddle } from '../../regular';
/**
 * 给试题赋值
 * @param info 试题对象
 * @param behavior 满足条件后的行为
 * @return Boolean
 */
export const SetAnswer = (info, behavior) => {
    // console.warn('4 :>> ', 4);
    // console.log('behavior :>> ', behavior);
    if (!behavior) return false
    let answer = InterceptMiddle(behavior, ['==', ':'], [']'])
    
    // console.log('answer :>> ', answer);
    switch (info.questionsTypeId) {
        case '11': // 星级评分
        case '38': // 量表题
            // console.log('info :>> ', info);
            if (answer) {
                if (info.questionsTypeId == '11' &&
                    answer >= info.lowestScore || 
                    answer <= info.highestScore
                ) {
                    info.userAnswer = parseInt(answer)
                } else if (info.questionsTypeId == '38' && 
                    answer >= info.startNum ||
                    answer <= orderSetting + info.startNum -1
                ){
                    info.userAnswer = parseInt(answer)
                }
            }
            break;
        case '6': // 图片选择
        case '8': // 单选题
        case '9': // 下拉框
        case '12': // 判断题
            info.optionList.forEach(op => {
                if (op.orderNum == answer) {
                    info.userAnswer = op.oid
                }
            })
            break;
        case '10': // 多选题
            info.optionList.forEach(op => {
                if (answer.indexOf(op.orderNum) != -1) {
                    info.userAnswerArr.push(op.oid)
                }
            })
            break;
        case '19': // 矩阵单选
        case '20': // 矩阵单选
            let rowArr1 = answer.split(',')
            rowArr1.forEach(item => {
                let sonOrderNum = item.split('==')[0]
                let opOrderNum = item.split('==')[1]
                info.questionsSonList.forEach((son,index) => {
                    if (sonOrderNum == son.orderNum) {
                        if (info.userAnswerArr.length == 0) {
                            info.questionsSonList.forEach(item =>{
                                info.userAnswerArr.push({
                                    SonId: item.SonId,
                                    value: ''
                                })
                            })
                        }
                        son.optionList.forEach(op => {
                            if (opOrderNum == op.orderNum && info.questionsTypeId == '19') {
                                info.userAnswerArr[index].value = op.oid
                                son.isSelected = op.oid
                            } else if(opOrderNum == op.orderNum && info.questionsTypeId == '20'){
                                op.isSelected = true
                                let str = info.userAnswerArr[index].value
                                if(str.indexOf(op.oid) == -1){
                                    info.userAnswerArr[index].value = str ? `${str},${op.oid}`: op.oid
                                }
                            }
                        })
                    }
                })
            });
        break;
        case '21': // 矩阵打分
        case '22': // 矩阵填空
            let rowArr2 = answer.split(',')
            rowArr2.forEach(item => {
                let quesNum = item.split('==')[0]
                let answer = item.split('==')[1]
                if (!quesNum) return
                let rowNum = quesNum ? quesNum.split('_')[0] : ''
                let optionNum = quesNum ? quesNum.split('_')[1] : ''
                info.questionsSonList.forEach((son,index) => {
                    if (rowNum == son.orderNum) {
                        son.optionList.forEach(op => {
                            if (optionNum == op.orderNum && info.questionsTypeId == '21') {
                                op.ratingScore = parseInt(answer)
                            } else if(optionNum == op.orderNum && info.questionsTypeId == '22'){
                                op.userAnswer = answer
                            }
                        })
                    }
                })
            })
            break;
    }
}

